export var MediaLinkingActionsTypes = /*#__PURE__*/function (MediaLinkingActionsTypes) {
  MediaLinkingActionsTypes["showToolbar"] = "MEDIA_SHOW_TOOLBAR";
  MediaLinkingActionsTypes["hideToolbar"] = "MEDIA_HIDE_TOOLBAR";
  MediaLinkingActionsTypes["setUrl"] = "MEDIA_SET_LINK_TO";
  MediaLinkingActionsTypes["unlink"] = "MEDIA_LINKING_UNLINK";
  return MediaLinkingActionsTypes;
}({});